module.exports = __webpack_public_path__ + "static/media/6.aacbb126.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/6.jpg
// module id = 152
// module chunks = 0